module.exports = __webpack_public_path__ + "img/img05.71415815.jpeg";